<app-investor-company-search-section
    [eventInfoWithConsent]="eventInfoWithConsent"
    [sectorNames]="sectorNames"
    (filterChange)="applyFilter($event)">
</app-investor-company-search-section>

<div class="mb-3 text-danger" id="time-timezone-text" *ngIf="isThailandFocus">
    Timezone : {{now | date:'zzz': 'UTC+7'}} (Bangkok time). The event will be conducted in physical event, unless selected virtual
</div>
<div class="mb-3 text-danger" id="time-timezone-local-text" *ngIf="!isThailandFocus">
    Timezone : {{now | date:'zzz'}} (Your local time)
</div>

<app-investor-company-select-section
    [companies]="filteredCompanies"
    [companySelectForm]="form"
    [isClosedRegis]="isClosedRegis"
    [defaultMeetingType]="defaultMeetingType"
    [defaultMeetingPriority]="defaultMeetingPriority"
    [attendancePreference]="attendancePreference"
    [eventInfoWithConsent]="eventInfoWithConsent"
    [stockExchanges]="stockExchanges">
</app-investor-company-select-section>

<div class="d-flex justify-content-between align-items-center mt-3">
    <div>Selected Companies: {{ selectedCount }}</div>
    <button class="btn btn-primary" (click)="onSubmit()" [disabled]="isClosedRegis || form.get('companies').value.length === 0">Save</button>
</div>